import { FEATURE_FLAG_FIELDS } from './featureFlags';

export const TENANT_FORM_FIELDS = {
  SYSTEM: {
    TITLE: 'System',
    FIELDS: [
      {
        label: 'Unique Tenant Identifier',
        name: 'identifier',
        type: 'text',
      },
      {
        label: 'Tenant Name',
        name: 'name',
        type: 'text',
      },
      {
        label: 'Website URL',
        name: 'webAppUrl',
        type: 'url',
      },
      {
        label: 'Branch',
        name: 'branch',
        type: 'text',
      },
      {
        label: 'Pipeline ID',
        name: 'pipelineId',
        type: 'number',
      },
      {
        label: 'Selection Algorithm Access URL',
        name: 'selectionAlgorithmNotebookUrl',
        type: 'url',
      },
      {
        label: 'Translation Provider',
        name: 'translationProvider',
        type: 'radio',
        options: [
          { label: 'Google', value: 'google' },
          { label: 'CMS', value: 'cms' },
        ],
      },
      {
        label: 'Google Analytics ID',
        name: 'googleAnalyticsId',
        type: 'text',
      },
    ],
  },
  DATABASE: {
    TITLE: 'Database',
    FIELDS: [
      {
        label: 'Host Name',
        name: 'databaseConfiguration.hostName',
        type: 'text',
      },
      {
        label: 'Database Name',
        name: 'databaseConfiguration.databaseName',
        type: 'text',
      },
      {
        label: 'User Name',
        name: 'databaseConfiguration.username',
        type: 'text',
      },
      {
        label: 'Password',
        name: 'databaseConfiguration.password',
        type: 'text',
      },
    ],
  },
  SENDGRID: {
    TITLE: 'SendGrid',
    FIELDS: [
      {
        label: 'API Key',
        name: 'sendGridConfiguration.apiKey',
        type: 'text',
      },
      {
        label: 'Email',
        name: 'sendGridConfiguration.senderEmail',
        type: 'email',
      },
    ],
  },
  TWILIO: {
    TITLE: 'Twilio',
    FIELDS: [
      {
        label: 'AuthToken',
        name: 'twilioConfiguration.authToken',
        type: 'text',
      },
      {
        label: 'Account Sid',
        name: 'twilioConfiguration.accountSid',
        type: 'email',
      },
      {
        label: 'Phone Number',
        name: 'twilioConfiguration.phoneNumber',
        type: 'phoneNumber',
      },
    ],
  },
  HOMEPAGE_CONFIG: {
    TITLE: 'Homepage Configuration',
    FIELDS: [
      {
        component: 'selectField',
        label: 'Family Font (Typography)',
        name: 'homePageConfiguration.fontFamilyName',
        options: [
          { label: 'PT Sans, sans-serif', value: 'PT Sans, sans-serif' },
          { label: 'Work Sans, sans-serif', value: 'Work Sans, sans-serif' },
        ],
      },
      {
        component: 'brandingField',
        label: 'Branding',
        name: 'homePageConfiguration.brandType',
      },
      {
        component: 'inputField',
        label: 'Site Name',
        name: 'homePageConfiguration.siteName',
      },
      {
        component: 'inputField',
        label: 'Program Long Name',
        name: 'homePageConfiguration.programLongName',
      },
      {
        component: 'inputField',
        label: 'Program Short Name',
        name: 'homePageConfiguration.programShortName',
      },
    ],
  },
  PAGE_CONTENT: {
    TITLE: 'Sign in and Sign Up page content',
    FIELDS: [
      {
        component: 'wysiwigField',
        label: 'Sign In / Sign Up Message',
        name: 'homePageConfiguration.signInMessage',
      },
    ],
  },
  READER_CONFIG: {
    TITLE: 'Reader Configuration',
    FIELDS: [
      {
        component: 'inputField',
        label: 'Number of Required Reads',
        name: 'readerConfiguration.requiredReads',
        type: 'number',
      },
      {
        component: 'inputField',
        label: 'Max Reads by Reader',
        name: 'readerConfiguration.maxReadsByReader',
        type: 'number',
      },
      {
        component: 'switchField',
        label: 'Diverse Ethnicity',
        name: 'readerConfiguration.diverseEthnicity',
      },
    ],
  },
  FEATURES: {
    TITLE: 'Features',
    FIELDS: FEATURE_FLAG_FIELDS,
  },
  DONATION_CONFIG: {
    TITLE: 'Donation Page Configuration',
    FIELDS: [
      {
        component: 'switchField',
        label: 'Show Donate CTA',
        name: 'donationPageConfiguration.isCtaVisible',
      },
    ],
  },
  FUNDS: {
    TITLE: 'Funds Disbursement',
    FIELDS: [
      {
        component: 'radioField',
        label: 'Disburse funds to Universities',
        name: 'fundsDisbursement',
        value: 'university',
      },
      {
        component: 'radioField',
        label: 'Disburse funds to students directly',
        name: 'fundsDisbursement',
        value: 'student',
      },
    ],
  },
  LEGAL: {
    TITLE: 'Legal',
    FIELDS: [
      {
        component: 'inputField',
        label: 'Copyright Language',
        name: 'legalConfiguration.copyrightLanguage',
      },
    ],
  },
  LOGIN: {
    TITLE: 'Sign In',
    FIELDS: [
      {
        label: 'Email',
        name: 'email',
        type: 'text',
      },
      {
        label: 'Password',
        name: 'password',
        type: 'password',
      },
    ],
  },
  BANNER: {
    TITLE: 'Site Banner',
    FIELDS: [
      {
        component: 'switchField',
        label: 'Show Banner',
        name: 'bannerConfiguration.isBannerEnabled',
      },
      {
        component: 'inputField',
        label: 'Banner Title',
        name: 'bannerConfiguration.title',
      },
      {
        component: 'inputField',
        label: 'Banner Description',
        name: 'bannerConfiguration.description',
      },
    ],
  },
  CODE_FLAGS: {
    TITLE: 'Code Flags',
    TOOLTIP_TEXT: 'Dynamic feature flags used to toggle on/off features in the code',
  },
};
